import axios from "axios"

const AUDIT_API_BASE_URL = (process.env.REACT_APP_AUDIT_API_BASE_URL ?? "/epermit-new-api").replace(/\/$/, "")
const AUDIT_APP_BASE_PATH = (process.env.REACT_APP_AUDIT_APP_BASE_PATH ?? "/epermit-new").replace(/\/$/, "")
const AUDIT_TOKEN_STORAGE_KEY = "EPERMIT_KEY"

export interface AuditTokenExchangeRequest {
  sourceToken: string
  requestedPath?: string | null
  requestedRoleId?: string | null
}

export interface AuditTokenExchangeResponse {
  statusCode?: number | null
  message?: string | null
  token?: string | null
  redirectPath?: string | null
  roles?: string[] | null
}

const ensureLeadingSlash = (value: string) => (value.startsWith("/") ? value : `/${value}`)

const buildAuditApiUrl = (path: string) => `${AUDIT_API_BASE_URL}${ensureLeadingSlash(path)}`

export const buildAuditAppUrl = (path = "/permit-audit") => {
  const normalizedPath = ensureLeadingSlash(path)
  return `${AUDIT_APP_BASE_PATH}${normalizedPath}`
}

export const setAuditToken = (token: string) => {
  localStorage.setItem(AUDIT_TOKEN_STORAGE_KEY, token)
}

export const clearAuditToken = () => {
  localStorage.removeItem(AUDIT_TOKEN_STORAGE_KEY)
}

export async function exchangeAuditToken(
  payload: AuditTokenExchangeRequest,
): Promise<AuditTokenExchangeResponse> {
  const response = await axios.post<AuditTokenExchangeResponse>(
    buildAuditApiUrl("/api/v1/auth/exchange-eptw-token"),
    payload,
  )
  const data = response.data ?? {}
  const statusCode = data.statusCode ?? 500
  if (statusCode !== 200 || !data.token) {
    throw new Error(data.message ?? "Unable to open Audit application.")
  }
  return data
}
